module.exports = __webpack_public_path__ + "img/temp logo.7685edf7.png";